import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplitButtonItemDirective, SplitButtonItemsDirective } from './items.directive';
import { SplitButtonComponent } from './splitbutton.component';
/**
 * NgModule definition for the SplitButton component.
 */
export class SplitButtonModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        SplitButtonComponent,
        SplitButtonItemDirective,
        SplitButtonItemsDirective
    ],
    exports: [
        SplitButtonComponent,
        SplitButtonItemDirective,
        SplitButtonItemsDirective
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SplitButtonModule_tsickle_Closure_declarations() {
/** @type {?} */
SplitButtonModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SplitButtonModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
